import React, { useEffect, useMemo, useState } from 'react';
import ProductCompareRepository from "../../../repository/ProductCompareRepository";
import { useProductStore } from 'src/hooks/product';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import ProductCompareClearAll from "../ProductCompareClearAll";
import ProductCompare from "@system/config/product-compare";

import closeIcon from 'src/assets/images/close-ic.png'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import System from 'src/helper/system';

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
        <div className='arrows-container'>
            <a className={currentSlide === 0 ? 'disable arrows arrows-left' : 'arrows arrows-left'}
                onClick={() => previous()}><i className='fa fa-chevron-circle-left'></i></a>
            <a className='arrows arrows-right' onClick={() => validateNext() && next()}><i className='fa fa-chevron-circle-right'></i></a>
        </div>
    );
};

const validateNext = () => {
    const compareBox = document.getElementsByClassName('compare-item-list-outer')[0].offsetWidth;
    const activeItem = document.getElementsByClassName('react-multi-carousel-track')[0].clientWidth;
    return (compareBox - (activeItem + 35) < 0);
}

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 7
    },
    largedesktop: {
        breakpoint: { max: 3000, min: 1400 },
        items: 7
    },
    desktop: {
        breakpoint: { max: 1400, min: 1024 },
        items: 6
    },
    tabletlandscape: {
        breakpoint: { max: 1024, min: 767 },
        items: 5
    },
    tablet: {
        breakpoint: { max: 767, min: 567 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 567, min: 0 },
        items: 2
    }
};

const ProductCompareMiniSlider = (props) => {
    const [{ model_ProductCompare_data }, { }, { }] = useProductStore();
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [__check] = useAxiosIndicatorCheck();
    const channel = useMemo(() => new BroadcastChannel('product-compare-toggled'), []);
    channel.addEventListener('message', async () => {
        await new ProductCompareRepository().fetchAllData();
    });
    const { translation:t } = System;
    useEffect(() => {
        async function fetchHere() {
            await new ProductCompareRepository().fetchAllData();
            setFirstServerCall(false)
        }

        if (firstServerCall) {
            fetchHere()
        }
    }, []);

    return (
        <>
            {model_ProductCompare_data && Object.keys(model_ProductCompare_data).length > 0 &&
                <div className="copmare-items-bottom-list position-fixed start-0">
                    <div className="container-fluid maxw100">
                        <div className="bs5 row">
                            {props.hideCompareSlider ? '' : <>
                                <>
                                    <div className="col-12 col-md p-0 position-relative compare-item-list-wrapper">
                                        <div className="compare-item-list-background" />
                                        {model_ProductCompare_data && Object.keys(model_ProductCompare_data).length > 0 &&
                                            <>
                                                <div className="compare-item-list-outer">
                                                    <Carousel
                                                        swipeable={false}
                                                        draggable={true}
                                                        showDots={false}
                                                        responsive={responsive}
                                                        ssr={true} // means to render carousel on server-side.
                                                        infinite={false}
                                                        autoPlay={false}
                                                        autoPlaySpeed={12000}
                                                        keyBoardControl={true}
                                                        customTransition="all .5"
                                                        transitionDuration={500}
                                                        containerClass="carousel-container"
                                                        removeArrowOnDeviceType={["mobile"]}
                                                        dotListClass="custom-dot-list-style"
                                                        itemClass="carousel-item-padding-40-px"
                                                        renderArrowsWhenDisabled={true}
                                                        arrows={false}
                                                        customButtonGroup={<ButtonGroup />}
                                                    >
                                                        {
                                                            Object.keys(model_ProductCompare_data).map((v, i) => (
                                                                <div key={v} className="comapre-item">
                                                                    <div className='pe-3'>
                                                                        <p className="product-link">{model_ProductCompare_data[v].ERPMFRPartNumber ? model_ProductCompare_data[v].ERPMFRPartNumber : ''}</p>
                                                                        <span
                                                                            className="manufacturer">{model_ProductCompare_data[v].ManufacturerName ? model_ProductCompare_data[v].ManufacturerName : ''}</span>
                                                                    </div>
                                                                    <div className="close-ic"
                                                                        onClick={async () => {
                                                                            await new ProductCompareRepository().toggleSingleProduct(model_ProductCompare_data[v])
                                                                            // new BroadcastChannel('product-compare-toggled').postMessage({}); // // 13546
                                                                            await new ProductCompareRepository().fetchAllData();
                                                                        }}
                                                                    >
                                                                        <img src={closeIcon} />
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </Carousel>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="col-12 col-md-auto p-0 align-self-center">
                                        {__check(['PRODUCT_COMPARE_API_CALL', { inline: true }]).render}
                                        {!__check(['PRODUCT_COMPARE_API_CALL']).status &&
                                            <div className="compare-actions">
                                                <ProductCompareClearAll />
                                                <a className={"bs5 btn btn-primary " + (Object.entries(model_ProductCompare_data).length <= 1 ? 'disabled' : '')}
                                                    onClick={(e) => {
                                                        window.location.href = ProductCompare.getProductComparePageRouteURL();
                                                    }} href={void (0)}>{t('compare')}
                                                    ({Object.entries(model_ProductCompare_data).length}/10)</a>
                                            </div>
                                        }
                                    </div>

                                </></>}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ProductCompareMiniSlider;